//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../Drawings/Drawings.ViewCenterCoordinateBuilder.js";
import "../Drawings/Drawings.ViewPlacementBuilder.js";
import "../Drawings/Drawings.HiddenObjectsBuilder.js";
import "../Drawings/Drawings.MultipleViewPlacementBuilder.js";
import "../Drawings/Drawings.ViewScaleBuilder.js";
import "../Drawings/Drawings.DraftingComponentSelectionBuilder.js";
import "../Drawings/Drawings.ViewStyleBuilder.js";
let d=[[[0,"Autoscale",1,0],[1,"Coordinate",0,"Drawings.ViewCenterCoordinateBuilder",0],[1,"HiddenObjects",0,"Drawings.HiddenObjectsBuilder",0],[0,"LayoutType",1,0],[0,"MarginBetweenViews",1,0],[0,"MarginToBorder",1,0],[1,"MultipleViewPlacement",0,"Drawings.MultipleViewPlacementBuilder",0],[1,"NonSectionedObjects",0,"Drawings.HiddenObjectsBuilder",0],[0,"Part",1,"Part",0],[1,"Scale",0,"Drawings.ViewScaleBuilder",0],[1,"SecondaryComponents",0,"Drawings.DraftingComponentSelectionBuilder",0],[1,"ViewStyle",0,"Drawings.ViewStyleBuilder",0],[0,"ViewType",1,0]],[],[]];
SPLM.Drawings.StandardViewsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.StandardViewsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.StandardViewsBuilder.Type = Object.freeze({
    "FrontTop" : "FrontTop", "FrontRight" : "FrontRight", "FrontLeft" : "FrontLeft", "FrontTopRight" : "FrontTopRight", "FrontTopLeft" : "FrontTopLeft", "FrontTopRightIso" : "FrontTopRightIso", "FrontTopLeftIso" : "FrontTopLeftIso"});

SPLM.Drawings.StandardViewsBuilder.View = Object.freeze({
    "Drawing" : "Drawing", "Base" : "Base"});

SPLM.Drawings.StandardViewsBuilder.Placement = Object.freeze({
    "Center" : "Center", "Corner" : "Corner"});

export default SPLM;